import { all, spawn, call } from 'redux-saga/effects';
import logger from 'helpers/logger';
import { powertrainConfigurationWatchers } from '../components/PowertrainTools/PowertrainConfiguration';
import { powertrainConfigurationWatchers as powertrainConfigurationWatchersV2 } from '../components/PowertrainTools/PowertrainConfigurationV2';
import { powertrainWizardWatchers as powertrainWizardWatchersV2 } from '../components/PowertrainTools/PowertrainConfigurationV2/PowertrainWizard';
import { powertrainWizardWatchers } from '../components/PowertrainTools/PowertrainConfiguration/PowertrainWizard';
import { reloadContextWatchers } from '../components/GeneralFilter/GeneralFilterModal/AssetSearch';
import { conditionIndicesOverviewWatchersV2 } from '../components/PowertrainConditionMonitoring/ConditionIndicesOverviewV2';
import { assetPictureUploadWatchers } from '../components/PowertrainAssetDetails/DetailedInformation/AssetDetails/Header/AssetNameplateImageHolder/assetImageSaga';
import { assetPhysicalConnectionWatchers } from '../components/PowertrainAssetDetails/DetailedInformation/AssetDetails/Header/AssetPhysicalConnection';
import { assetConditionalInsightsWatchers } from '../components/PowertrainAssetDetails/DetailedInformation/ConditionInsights/conditionInsightsSaga';
import { notificationSettingsWatchers } from '../components/UserProfileSettings/NotificationSettings';
import { limitConfigWatchers } from '../components/PowertrainAssetDetails/DetailedInformation/LimitConfigurationBeta';
import { notificationPanelWatchers } from '../components/PowertrainOverview/Header/NotificationDropdown';
import { GatewayManagementWatchers, GatewayTypeWatchers, GatewayDetailsWatchers, GatewayDriveApplicationsWatchers, GatewayUpdateAssetDriveApplicationWatchers } from '../components/PowertrainTools/GatewayManagement';
import { GatewayManagementInfoWatchers, GatewayManagementConnectedAssetsWatchers, GatewayUserCapabilitiesWatchers } from '../components/PowertrainTools/GatewayManagement/GatewayDetails';

import { SensorFirmwareManagementWatchers } from '../components/PowertrainTools/SensorFirmwareManagement';
import { dataLoggerWatchers } from '../components/PowertrainAssetDetails/DetailedInformation/Header/DataLogger/DataLoggerSaga';
import { parameterFileRequestWatchers } from '../components/PowertrainAssetDetails/DetailedInformation/Header/ParameterBackupV2/ParameterBackupSaga';
import { bulkUploadRequestWatchers } from '../components/PowertrainAssetDetails/DetailedInformation/Header/BulkUploadV2/BulkUploadV2Saga';
import { changedParameterListV2Watchers } from '../components/PowertrainAssetDetails/DetailedInformation/Header/ChangedParameterListV2/ChangedParameterListSagaV2';
import { vibrationFFTV2Watchers } from '../components/PowertrainAssetDetails/DetailedInformation/OperationalParametersV2/VibrationFFTV2';
import { ValidateSerialNumberWatchers, AssignSerialNumberWatchers } from '../components/PowertrainTools/GatewayManagement/SerialNumberEditor/SerialNumberEditorSaga';
import { watchDeleteAsset } from '../components/PowertrainTools/GatewayManagement/GatewayDetails/ConnectedAssets/ConnectedAssetsDrives/DeleteAsset/DeleteAssetSaga';
import { ParameterBackupWatchers } from '../components/PowertrainTools/GatewayManagement/GatewayDetails/ConnectedAssets/ConnectedAssetsDrives/ParameterBackup/ParameterBackupSaga';
import { refreshGatewayWatchers } from '../components/PowertrainTools/GatewayManagement/GatewayDetails/Header/RefreshGateway/RefreshGatewaySaga';
import { RebootGatewayWatchers } from '../components/PowertrainTools/GatewayManagement/GatewayDetails/Header/RebootGateway/RebootGatewaySaga';
import { activateDeactivateGatewayWatchers, lastCommandStatusActivateRemoteConnectionWatchers } from '../components/PowertrainTools/GatewayManagement/GatewayDetails/Header/ActivateDeactivateGateway/ActivateDeactivateGatewaySaga';
import { gatewayDetailsWatchers } from '../components/PowertrainTools/GatewayManagement/GatewayDetails/Header/DeleteGateway/DeleteGatewaySaga';
import { exportMessageArchiveWatchers } from '../components/PowertrainTools/GatewayManagement/GatewayDetails/Header/ExportMessageArchive/ExportMessageArchiveSaga';
import { DisconnectAssetWatchers } from '../components/PowertrainTools/GatewayManagement/GatewayDetails/ConnectedAssets/ConnectedAssetsDrives/DisconnectAsset/DisconnectAssetSaga';
import { enableDisableDriveWatchers } from '../components/PowertrainTools/GatewayManagement/GatewayDetails/ConnectedAssets/ConnectedAssetsDrives/EnableDisableDrive/EnableDisableDriveSaga';
import { updateFirmwareWatchers } from '../components/PowertrainTools/GatewayManagement/GatewayDetails/Header/UpdateFirmware/UpdateFirmwareSaga';
import { GatewayManagementDownloadInstallationReportWatchers, GatewayManagementDownloadDiagnosticReportWatchers, GatewayManagementConnectionHistoryGatewayWatchers, GatewayManagementConnectionHistoryAssetWatchers, GatewayManagementConnectedHistoryWatchers, GatewayManagementRssiHistoryWatchers } from '../components/PowertrainTools/GatewayManagement/GatewayDetails/GatawayDetailsSaga';
import { SwitchToAnotherGatewayWatchers, ValidateSwitchAssetGatewayWatchers, GetAssetsForGatewayWatchers } from '../components/PowertrainTools/GatewayManagement/GatewayDetails/ConnectedAssets/ConnectedAssetsDrives/SwitchToAnotherGateway/SwitchToAnotherGatewaySaga';
import { MoveToAnotherGatewayWatchers, ValidateAssetGatewayWatchers } from '../components/PowertrainTools/GatewayManagement/GatewayDetails/ConnectedAssets/ConnectedAssetsDrives/MoveToAnotherGateway/MoveToAnotherGatewaySaga';
import { disconnectEnvironmentSensorWatchers } from '../components/PowertrainTools/GatewayManagement/GatewayDetails/ConnectedAssets/ConnectedAssetsEnvironmentSensors/DisconnectEnvironmentSensor/DisconnectEnvironmentSensorSaga';
import { watchFleetOverviewRootSaga } from '../components/PowertrainFleets/FleetOverview/FleetOverviewSaga';
import { gatewayEventsSagaWatchers } from '../components/PowertrainTools/GatewayManagement/GatewayEvents/GatewayEventsSaga';
import { TrendCommentsWatchers } from '../components/PowertrainAssetDetails/DetailedInformation/OperationalParametersV2/SingleChartView/Trend/TrendComments';

export function* rootSaga() {
    const sagas = [
        powertrainConfigurationWatchersV2,
        powertrainWizardWatchersV2,
        powertrainConfigurationWatchers,
        powertrainWizardWatchers,
        reloadContextWatchers,
        conditionIndicesOverviewWatchersV2,
        assetPictureUploadWatchers,
        assetPhysicalConnectionWatchers,
        assetConditionalInsightsWatchers,
        notificationSettingsWatchers,
        limitConfigWatchers,
        notificationPanelWatchers,
        GatewayManagementWatchers,
        SensorFirmwareManagementWatchers,
        dataLoggerWatchers,
        GatewayManagementInfoWatchers,
        GatewayManagementConnectedAssetsWatchers,
        ValidateSerialNumberWatchers,
        GatewayTypeWatchers,
        AssignSerialNumberWatchers,
        GatewayDetailsWatchers,
        parameterFileRequestWatchers,
        bulkUploadRequestWatchers,
        changedParameterListV2Watchers,
        vibrationFFTV2Watchers,
        watchDeleteAsset,
        DisconnectAssetWatchers,
        ParameterBackupWatchers,
        refreshGatewayWatchers,
        RebootGatewayWatchers,
        activateDeactivateGatewayWatchers,
        lastCommandStatusActivateRemoteConnectionWatchers,
        gatewayDetailsWatchers,
        enableDisableDriveWatchers,
        updateFirmwareWatchers,
        GatewayUserCapabilitiesWatchers,
        GatewayManagementDownloadInstallationReportWatchers,
        GatewayManagementDownloadDiagnosticReportWatchers,
        GatewayDriveApplicationsWatchers,
        GatewayUpdateAssetDriveApplicationWatchers,
        SwitchToAnotherGatewayWatchers,
        ValidateSwitchAssetGatewayWatchers,
        GetAssetsForGatewayWatchers,
        MoveToAnotherGatewayWatchers,
        ValidateAssetGatewayWatchers,
        disconnectEnvironmentSensorWatchers,
        watchFleetOverviewRootSaga,
        gatewayEventsSagaWatchers,
        TrendCommentsWatchers,
        exportMessageArchiveWatchers,
        GatewayManagementConnectionHistoryGatewayWatchers,
        GatewayManagementConnectionHistoryAssetWatchers,
        GatewayManagementConnectedHistoryWatchers,
        GatewayManagementRssiHistoryWatchers
        // Add other component-specific Sagas here if needed
    ];
    yield all(sagas.map(saga =>
        spawn(function* () {
            while (true) {
                try {
                    yield call(saga);
                    break;
                } catch (e) {
                    logger.error(e);
                }
            }
        })
    ));
}
